"use strict";

require("core-js/modules/es6.object.assign");

require("core-js/modules/es6.object.define-property");

require("core-js/modules/es6.symbol");

require("core-js/modules/es6.array.index-of");

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var recharts_1 = require("recharts");

var styled_1 = require("./styled");
/**
 * Chart Card component
 *
 * Card component with an area graph as the background.
 *
 */


var ChartCard = function ChartCard(_a) {
  var children = _a.children,
      _a$data = _a.data,
      data = _a$data === void 0 ? [] : _a$data,
      rest = __rest(_a, ["children", "data"]);

  return react_1["default"].createElement(styled_1.Wrapper, Object.assign({}, rest), react_1["default"].createElement(recharts_1.ResponsiveContainer, {
    debounce: 1
  }, react_1["default"].createElement(recharts_1.AreaChart, {
    data: data
  }, react_1["default"].createElement(recharts_1.Area, {
    type: "monotone",
    dataKey: "value",
    fillOpacity: 0.1,
    fill: "#0AC18E",
    stroke: "#0AC18E",
    strokeWidth: 2
  }))), react_1["default"].createElement(styled_1.CardContent, Object.assign({}, rest), children));
};

exports["default"] = ChartCard;